import getSubtest from "./getSubtest";
import values from 'mout/object/values'
import sortByPropText from "../content/manageSets/sortByPropText";
import totalArray from "../totalArray";
import checkRating from "./checkRating";
/*
5: >1.8
4: >1.5
3: >1.0
2: >0.5
1: <=0.5
*/

export default function getProcessOfEliminationRating(userAssessment) {

  const ratingThresholds = {
    'Composite': [
      {percent: 1.8, rating: 5},
      {percent: 1.5, rating: 4},
      {percent: 1.0, rating: 3},
      {percent: 0.5, rating: 2},
      {percent: 0.49, rating: 1},
    ]
  }
  const FRONT_FRACTION = 0.75
  const FIRST_ITEM = 4
  const LAST_ITEM = 9

  function findFrontFractionOfSubtest(userAssessment, subject) {
    const subtest = getSubtest(subject, userAssessment)
    const subtestId = subtest.setId
    const items = sortByPropText(values(userAssessment.scoring.byItem[subtestId]), 'index')
    return items.slice(0, Math.round(items.length * FRONT_FRACTION))
  }

  function findWorstPerformingItems(userAssessment, subject) {
    const items = findFrontFractionOfSubtest(userAssessment, subject)
    const sortedItems = items.sort(function sortByPercent(a, b) {
      if (a.possible == 0 && b.possible == 0) {
        return 0
      } else if (a.possible == 0) {
        return -1
      } else if (b.possible == 0) {
        return 1
      } else if (a.raw / a.possible < b.raw / b.possible) {
        return -1
      } else if (a.raw / a.possible > b.raw / b.possible) {
        return 1
      } else return 0
    })
    return sortedItems.slice(FIRST_ITEM - 1, LAST_ITEM)
  }

  function averagePercentCorrect(items) {
    let raw = 0, possible = 0
    items.forEach(function addUp(item) {
      raw += parseInt(item.raw, 10)
      possible += parseInt(item.possible, 10)
    })
    return possible ? raw / possible : 0
  }

  // Next steps: Find the percent average of the worst performing items, then compute the number of eliminations
  function calculateEliminationsOneSubject(userAssessment, subject) {
    const items = findWorstPerformingItems(userAssessment, subject)
    const percent = averagePercentCorrect(items)
    if (percent === 0) {
      return 0
    } else if (subject === 'Math') {
      return 6.1 - ( 1 / percent)
    } else {
      return 5.1 - ( 1/ percent )
    }
  }

  function calculateEliminationsAllSubjects(userAssessment) {
    let eliminations = {}
    const subjects = ['English', 'Math', 'Reading', 'Science']
    subjects.forEach((subject) => {
      eliminations[subject] = parseFloat(calculateEliminationsOneSubject(userAssessment, subject).toFixed(2))
    })
    eliminations['Composite'] = parseFloat((totalArray(values(eliminations)) / 4).toFixed(2))
    return eliminations
  }

  function getRating(userAssessment) {
    const eliminations = calculateEliminationsAllSubjects(userAssessment)
    function ratingTest (r, score) {
      return score > r.percent
    }
    const rating = checkRating(ratingThresholds, 'Composite', eliminations['Composite'], ratingTest)
    return {
      stars: rating,
      eliminations,
    }
  }

  return getRating(userAssessment)
}


/*

  processOfElimination: {
    stars: 1,
    eliminations: {
      Composite: 2.3,
      English: 1.5,
      Math: 2.2,
      Reading: 2.8,
      Science: 0.0,
    }
  },

In the front three-fourths of each test, take the 4th- through 9th-worst performing questions. 

ERS:
Eliminations = 5.1 - (1/PercCorrect)

M:
Eliminations = 6.1 - (1/PercCorrect)

Composite:
Average of all 4.

5: >1.8
4: >1.5
3: >1.0
2: >0.5
1: <=0.5
*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getProcessOfEliminationRating.js